import axios from "axios";
import { Store } from "../redux/store/store";
import { notifyUser } from "./notifyUser";
import { LOGOUT } from "../redux/actions/authActions";
import { LINEAR_LOADING } from "../redux/actions/commonActions";
import exportToExcel from "./exportToExcel";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 0,
});

axiosInstance.interceptors.request.use(
  (config) => {
    Store.dispatch(LINEAR_LOADING(true));
    const state = Store.getState();
    const { token } = state.auth;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    Store.dispatch(LINEAR_LOADING(false));
    return Promise.reject(err);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    Store.dispatch(LINEAR_LOADING(false));
    return response;
  },
  (err) => {
    const { data, status } = err?.response || {};
    const { error, message, type, excelData } = data || {
      error: "Something went wrong",
    };
    const is401or403 = status === 401 || status === 403;
    const errMessage =
      error || message || err?.message || "Something went wrong";
    !is401or403 && notifyUser({ message: errMessage, type: "error" });
    if (type === "file") {
      exportToExcel({ data: excelData, filename: "Error_report.xlsx" });
      setTimeout(() => {
        notifyUser({
          message: "Downloading Error Report",
          type: "info",
        });
      }, 500);
    }
    Store.dispatch(LINEAR_LOADING(false));
    if (is401or403) {
      Store.dispatch(LOGOUT());
    }
    return Promise.reject(err);
  }
);

export default axiosInstance;
